var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68819 10.7605L10.4646 3.98404C11.7669 2.68179 13.8764 2.68179 15.1787 3.98404C16.4809 5.2863 16.4809 7.39583 15.1787 8.69809L7.81298 16.0638C7.42228 16.4545 6.89238 16.674 6.33984 16.674C5.78731 16.674 5.25741 16.4545 4.8667 16.0638C4.476 15.6731 4.25651 15.1432 4.25651 14.5906C4.25651 14.0381 4.476 13.5082 4.8667 13.1175L11.0539 6.93032C11.378 6.60623 11.9083 6.60623 12.2324 6.93032C12.5565 7.25441 12.5565 7.78474 12.2324 8.10883L6.63447 13.7068L7.51836 14.5906L13.1163 8.99271C13.507 8.60201 13.7265 8.07211 13.7265 7.51957C13.7265 6.96704 13.507 6.43714 13.1163 6.04644C12.7256 5.65573 12.1957 5.43624 11.6431 5.43624C11.0906 5.43624 10.5607 5.65573 10.17 6.04643L3.98282 12.2336C2.68057 13.5359 2.68057 15.6454 3.98282 16.9477C5.28508 18.2499 7.39461 18.2499 8.69687 16.9477L16.0626 9.58197C17.8539 7.79063 17.8539 4.89149 16.0626 3.10016C14.2712 1.30882 11.3721 1.30882 9.58075 3.10016L2.80431 9.8766L3.68819 10.7605Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.4037f2d7f149ff21c9e2d6a02bc64b17.svg";
export { ForwardRef as ReactComponent };